import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles/utils/fill";
import { classNames } from "../../../utils";
export function Google(t0) {
  const $ = _c(16);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      size: t1,
      fill: t2,
      fillAttribute: t3,
      className,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const size = t1 === undefined ? 24 : t1;
  const fill = t2 === undefined ? "current" : t2;
  const fillAttribute = t3 === undefined ? "currentColor" : t3;
  let t4;
  if ($[6] !== className || $[7] !== fill) {
    t4 = classNames(fillVariants({
      fill
    }), className);
    $[6] = className;
    $[7] = fill;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <g clipPath="url(#clip0_2196_47208)"><path d="M0 10C0 4.486 4.486 0 10 0C12.227 0 14.3348 0.716476 16.0956 2.072L13.7718 5.09067C12.683 4.25257 11.3788 3.80952 10 3.80952C6.58657 3.80952 3.80952 6.58657 3.80952 10C3.80952 13.4134 6.58657 16.1905 10 16.1905C12.7492 16.1905 15.0855 14.3892 15.8907 11.9048H10V8.09524H20V10C20 15.514 15.514 20 10 20C4.486 20 0 15.514 0 10Z" /></g>;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <defs><clipPath id="clip0_2196_47208"><rect height="20" width="20" /></clipPath></defs>;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== fillAttribute || $[12] !== rest || $[13] !== size || $[14] !== t4) {
    t7 = <svg aria-label="Google" className={t4} fill={fillAttribute} height={size} viewBox="0 0 20 20" width={size} xmlns="http://www.w3.org/2000/svg" {...rest}>{t5}{t6}</svg>;
    $[11] = fillAttribute;
    $[12] = rest;
    $[13] = size;
    $[14] = t4;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}